module.exports = __webpack_public_path__ + "img/pic1@2x.920327c5.png";